export const TRACK_EVENT = '@@hublytics';